import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FloatLabelModule } from 'primeng/floatlabel';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'select-input-field',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FloatLabelModule, SelectModule],
  templateUrl: './select-input-field.component.html',
  styleUrl: './select-input-field.component.scss',
})
export class SelectInputFieldComponent {
  @Input() label = '';
  @Input() options: { id: string; displayValue: string }[] = [];
  @Input({ required: true }) control!: FormControl;
  @Input() prefixIcon?: string;
  @Input() suffixIcon?: string;
  @Input() errorMessage?: string;
  @Output() changed = new EventEmitter<string>();
}
